import React, { ComponentType } from 'react'
import { FormatStartDate } from '../utils/startDate'
import { Header } from '../Header/Header'

interface LinkProps {
  permalink: string
  title?: string
  createdDate?: string
}

export interface MediaSearchResultItem {
  image?: {
    poster?: string
  }
  permalink: string
  title?: string
  createdDate?: string
  RenderLink?: ComponentType<LinkProps>
}

export interface MediaSearchResultProps {
  items: MediaSearchResultItem[]
}

const RenderLinkDefault = ({ title, permalink, createdDate }: LinkProps) => (
  <a href={permalink} aria-label={title}>
    {title}
    <p>{createdDate && FormatStartDate(createdDate, 'MMM dd, yyyy')}</p>
  </a>
)

export const MediaSearchResult = ({ items }: MediaSearchResultProps) => (
  <div className="column__main">
    <div className="column__three column--merge-a">
      {items.map((item) => {
        if (!item) return null
        const {
          image,
          permalink,
          title,
          createdDate,
          RenderLink = RenderLinkDefault
        } = item

        const background =
          image && image.poster
            ? { backgroundImage: `url(${image.poster})` }
            : { backgroundColor: '#171721' }

        return (
          <div className="column search__media" key={permalink}>
            <div
              className="search__media--image bg--img bg--blend box box--4"
              style={background}
            >
              <Header level={4} className="heading--6">
                <RenderLink
                  permalink={permalink}
                  title={title}
                  createdDate={createdDate}
                />
              </Header>
            </div>
            <button className="play-icon" type="button">
              <span className="play-icon--placeholder" />
            </button>
          </div>
        )
      })}
    </div>
  </div>
)
